@defer {
  <router-outlet [ngClass]="{ 'app-cookie-consent': showBanner }" />
  <dn-cookie-consent *ngIf="showBanner" [baseUrl]="baseUrl" (onUserAction)="onCookieConsentClick()" />
}
